<template>
	<div id="content_body">
		<!-- :instanceClass="instanceClassAttr.instanceClass" -->
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- invoice -->
			<div class="card">
				<div class="card-header">
					<b-form ref="instanceForm" id="instanceForm" autocomplete="off" >
						<!-- Flash -->
						<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
						<div class="form-row">
							<!-- :class="{'is-invalid': v$.instance.prsStore.$error, 'is-valid': (!v$.instance.prsStore.$error && v$.instance.prsStore.$dirty) }" -->
									<!-- || !$store.getters.isAuthorized(['ROLE_MANAGER']) -->
							<!-- <div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
									</label>
									<select v-model="prsStoreSelected" 
										class="form-control" :disabled="typeView=='show' || typeView=='edit'" @change="prsStoreChange()">
										<option value="null" selected>
											{{$t('default.fill.field.message')}}
										</option>
										<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id" >
										{{ prsStore.storeName }}
										</option>
									</select>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.prsStore && v$.instance.prsStore.$error">
										{{ v$.instance.prsStore.$errors[0].$message }}
									</span>									
								</b-form-group>
							</div> -->
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.orderNumber')}}
									</label>
									<input type="text" v-model="instance.orderNumber" class="form-control"
									:class="{'is-invalid': v$.instance.orderNumber.$error, 'is-valid': (!v$.instance.orderNumber.$error && v$.instance.orderNumber.$dirty) }" :disabled="typeView=='show' || instance.orderNumber"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.orderNumber.$error">
										{{ v$.instance.orderNumber.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.orderDate')}}
									</label>
									<input type="date" v-model="instance.orderDate" class="form-control" lang="fr"
									:class="{'is-invalid': v$.instance.orderDate.$error, 'is-valid': (!v$.instance.orderDate.$error && v$.instance.orderDate.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.orderDate.$error">
										{{ v$.instance.orderDate.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-10">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.personId')}}
									</label>
									<input v-if="['show', 'edit'].includes(typeView)" type="text" v-model="instance.person" class="form-control" disabled/>
									<!-- v-show="typeView != 'show'" -->
									<auto-search v-show="['new'].includes(typeView)" :paramsSearch="paramsSearch" @updateOnClick="addPerson" :key="autoSearchPrsKey" :class="{'is-invalid': v$.instance.personId.$error, 'is-valid': (!v$.instance.personId.$error && v$.instance.personId.$dirty) }" :disabled="typeView=='show'"/>
									<input type="text" v-model="instance.personId" class="form-control" :class="{'is-invalid': v$.instance.personId.$error, 'is-valid': (!v$.instance.personId.$error && v$.instance.personId.$dirty) }" hidden=""/> 
									<span style="color:red;" class="small d-none d-md-block" v-if="v$.instance.personId.$error">
										{{ v$.instance.personId.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>
							<div class="col-md-2">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.autoDestock')}}
									</label>
									<input type="checkbox" v-model="instance.autoDestock" class="form-control"
									:disabled="['show', 'edit'].includes(typeView)"/>
								</b-form-group>
							</div>
							<!-- PAYMENT AUTO -->
							<legend>
								<h6 class="fst-italic text-decoration-underline text-danger ">
									RÉGLER AUTOMATIQUEMENT ?
								<input type="checkbox" v-model="instance.payAuto" :disabled="['show', 'edit'].includes(typeView)"/>
								</h6>
							</legend>
							<div v-if="instance.payAuto" class="col-md-12">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.accountPay')}}
									</label>
									<select v-model="accountPaySelected" class="form-control" :disabled="['show', 'edit'].includes(typeView)">
										<option value="null" selected>
											{{$t('default.fill.field.message')}}
										</option>
										<option v-for="mvtAccountInv in mvtAccountInvList" :value="mvtAccountInv.id" :key="mvtAccountInv.id">
										{{ mvtAccountInv.lib}} | Solde: {{$store.getters.formatAmount(mvtAccountInv.solde)}}
										</option>
									</select>
															
								</b-form-group>
							</div>

						</div>
						
					</b-form>
					
				</div>
				<div class="card-body p-4 p-md-5">
					<!-- Ops table-->
					<div class="table-responsive">
						<span class="small text-muted d-none d-md-block" v-if="v$.instance.purchaseOrderItems.$error">
							{{ v$.instance.purchaseOrderItems.$errors[0].$message }}
						</span>
						<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
							<thead class="border-bottom thead-light">
								<tr class="small text-uppercase text-muted">
									<th scope="col" width="45%">
										{{ $t(instanceClassAttr.instanceClass+'.servType')}}
									</th>
									<th scope="col" width="30%" class="align-center">
										{{ $t(instanceClassAttr.instanceClass+'.quantity')}}
									</th>
									<th scope="col" width="15%" class="align-right">
										{{ $t(instanceClassAttr.instanceClass+'.cost')}}
									</th>
									<th scope="col" v-if="typeView != 'show'" width="10%" class="align-center">
										{{ $t('default.actions')}}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr class="border-bottom" v-for="purchaseOrderItem in instance.purchaseOrderItems" :key="purchaseOrderItem.id">
									<!--  -->
									<td>
										<div class="font-weight-bold">
											{{purchaseOrderItem.lib}}
											<!-- {{purchaseOrderItem.servTypeLib}} -->
											<!--  |
											<em style="color:red;">
												{{$store.getters.formatAmount(purchaseOrderItem.price)}}
											</em> -->
											
										</div>
									</td>
									<td>
									<div class="input-group small text-muted">
										<span v-show="typeView !='show'" class="input-group-text text-danger">
											<b v-if="purchaseOrderItem.cost > 0 && purchaseOrderItem.quantity >0"><em> P.U: {{$store.getters.formatAmount( purchaseOrderItem.cost / purchaseOrderItem.quantity)}}</em></b>
										</span>
										<input type="number" min="1" v-model="purchaseOrderItem.quantity" class="form-control" :disabled="typeView=='show'"/>
									</div>
									</td>
									<td>
										<div class="fw-bold align-right">
											<input type="number" step="any" v-model="purchaseOrderItem.cost" class="form-control" :disabled="typeView=='show'" @input="amountToLetter($event, 'itemCost')" @change="amountLetter = {}; prsAmountChange()"/>
										</div>
										<span v-if="amountLetter && amountLetter.itemCost != '' " class="amount-letter">
											{{amountLetter.itemCost}}
										</span>
									</td>
									<td v-if="typeView != 'show'" class="align-center">
										<!-- font-weight-bold -->
										<div class=""> 
											<button v-show="!purchaseOrderItem.edit" class="btn btn-danger btn-icon btn-xs" @click="removeRow(purchaseOrderItem)">
												<fa icon="minus"/>
											</button>
										</div>
									</td>
								</tr>
								<tr v-if="typeView != 'show'" class="border-bottom table-warning">
									<td v-show="activeAddRow" align="center" colspan="4" >
										<auto-search :paramsSearch="paramsSearchArt" @updateOnClick="addRow" :key="autoSearchKey"/>
									</td>
									<td v-show="!activeAddRow" align="center" colspan="4"
									>
										<b-button class="btn btn-sm btn-success" 
											@click="activeAddRow=true; autoSearchKey++;" >
											<span>
												<fa class="fa-lg" icon="plus-circle"/>
											</span>
										</b-button>
									</td>
								</tr>
								<!-- DISCOUNT -->
								<tr v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])" class="border-bottom table-warning">
									<td align="center" colspan="1" >
										<div class="fw-bold align-right" >
											{{ $t(instanceClassAttr.instanceClass+'.discount')}}
										</div>
									</td>
									<td align="center" colspan="3" >
										<div class="fw-bold align-right">
											<input type="number" step="any" v-model="instance.discount" class="form-control" :disabled="typeView=='show'" @input="amountToLetter($event, 'amount')" @change="amountLetter = {}; prsAmountChange()"/>
											<span v-if="amountLetter && amountLetter.amount != '' " class="amount-letter">
												{{amountLetter.amount}}
											</span>

										</div>
									</td>
								</tr>
								<!-- CHARGES -->
								<tr v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])" class="border-bottom table-warning">
									<td align="center" colspan="1" >
										<div class="fw-bold align-right" >
											{{ $t(instanceClassAttr.instanceClass+'.charges')}}
										</div>
									</td>
									<td align="center" colspan="3" >
										<div class="fw-bold align-right">
											<input type="number" step="any" v-model="instance.charges" class="form-control" :disabled="typeView=='show'" @input="amountToLetter($event, 'charges')" @change="amountLetter = {}; prsAmountChange()"/>
											<span v-if="amountLetter && amountLetter.charges != '' " class="amount-letter">
												{{amountLetter.charges}}
											</span>

										</div>
									</td>
								</tr>

								<!-- TOTAL -->
								<tr v-if="instance.cost" class="border-bottom table-warning">
									<td align="center" colspan="1" >
										<div class="fw-bold fs-2 align-right" >
											Total de la comande
										</div>
									</td>
									<td align="center" colspan="3" >
										<div class="fw-bold fs-2 align-right">
											{{$store.getters.formatAmount(instance.cost)}}
										</div>
									</td>
								</tr>
								<tr v-if="amountLetter && amountLetter.cost" class="border-bottom table-warning">
									<!-- <td align="center" colspan="2" >
										<div class="fw-bold fs-2 align-right" >
											Total de la comande
										</div>
									</td> -->
									<td align="center" colspan="4" >
										<div class="fw-bold fst-italic align-right">
											{{amountLetter.cost}}
										</div>
									</td>
								</tr>

								<!-- OBSERVATION EN CAS DE RISTOURNE OU RETOUR -->
								<tr class="border-bottom table-warning">
									<td align="center" colspan="0" >
										<div class="fw-bold align-right" >
											{{ $t(instanceClassAttr.instanceClass+'.observation')}}
										</div>
									</td>
									<td align="center" colspan="4" >
										<div class="fw-bold align-left">
											<input type="text" v-model="instance.observation" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
								</tr>
								
							</tbody>
						</table>
					</div>
				</div>
				<div class="card-footer" v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_SUIVI'])">
					<div class="row">
						<div class="col-md-6" align="left">
							<b-button v-if="typeView != 'show' && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-success" 
								@click="handleSubmit()" >
								<span v-if="typeView == 'new'">
									<fa icon="check"/>
									{{ $t("default.button.create")}}
								</span>
								<span v-if="typeView == 'edit'">
									<fa icon="check"/>
									{{ $t("default.button.update")}}
								</span>
							</b-button>
							&ensp;
							<b-button v-if="typeView == 'edit' && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-dark" @click="editItem" >
								<span>
									<fa icon="times"/>
									{{ $t("default.button.cancel")}}
								</span>
							</b-button>
							
							<b-button v-if="typeView == 'show' && ['EP', 'EN'].includes(instance.servStatus.code) && $store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])" class="btn btn-primary" 
								@click="editItem" >
								<span>
									<fa icon="edit"/>
									{{ $t("default.button.edit")}}
								</span>
							</b-button>
							&ensp;
							<b-button v-if="typeView == 'show' && ['EP', 'EN'].includes(instance.servStatus.code) && $store.getters.isAuthorized(['ROLE_MANAGER'])" class="btn btn-success" 
								@click="instance.typeValid = 'valid'; axiosValid()">
								<span>
									<fa icon="check"/>
									{{ $t("purchaseorder.button.valid")}}
								</span>
							</b-button>
							<b-button v-if="typeView == 'show' && ['LP', 'LN'].includes(instance.servStatus.code) && $store.getters.isAuthorized(['ROLE_MANAGER'])" class="btn btn-danger" 
								@click="instance.typeValid = 'invalid'; axiosValid()">
								<span>
									<fa icon="reply"/>
									{{ $t("purchaseorder.button.invalid")}}
								</span>
							</b-button>
						</div>
						<div v-if="typeView == 'show'" class="col-md-6" align="right">
							<b-button id="print"
								variant="primary" class="btn btn-info" type="button" @click="produce('bord')">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('purchaseorder.button.bord')}}
							</b-button>
							&ensp;
							<b-button id="print"
								variant="primary" class="btn btn-info" type="button" @click="produce('bill')">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('purchaseorder.button.bill')}}
							</b-button>
							<modal-pdf-viewer 
								ref="componentModalPdf" 
								:pdfSrc="pdfSrc"
								:pdfName="pdfName"
							/>
						</div>
					</div>


				</div>
				
			</div>
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import AutoSearch from '@/components/templates/AutoSearch.vue';
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue'
	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'

	export default {
		name: 'purchaseOrder',
		props: {
			itemId: {
				type: Number,
				default: NaN,
				required: false
			}
		},
		
		setup () { return { v$: useVuelidate() }},
		components: {
			'header-layout': Header,
			'auto-search': AutoSearch,
			'modal-pdf-viewer': ModalPdfViewer
		},
		
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('purchaseorder.label'),
				pageTitle: this.$t('purchaseorder.list'),
				pageIcon: 'tags',
				instanceClassAttr: {
					instanceClass: 'purchaseorder'
				},
				instance: {
					orderDate: new Date ().toISOString().split('T')[0],
					orderNumber: 'AUTO',
					person: '',
					purchaseOrderItems:[],
					charges: 0,
					discount: 0,
					autoRecep: true,
					autoDestock: false,
					payAuto: false,
					servStatus: {id:3} // en cours no payé
					// servStatus: {id:1} // si payAuto en cours
				},
				vueRules: {},
				amountLetter: {},
				paramsSearch: {
					placeholder: 'Search Fournisseur',
					instanceClass: 'prsperson',
					attrsSearch : ['firstName', 'lastName'],
					attrView: 'fullName',
					defaultValue: this.instance?.person,
					filterList: [],
					btnReturn: false,
					icon: 'user',
				},
				paramsSearchArt: {
					placeholder: 'Search Products',
					attrView: 'lib',
					// defaultValue: this.instance?.person,
					filterList: [],
					listOpen: true,
					btnReturn: true,
					icon: 'cart-plus',
				},
				prsStoreList: [],
				prsStoreSelected: null,
				prsPersonList:[],
				purchaseOrderItems: {},
				accountPaySelected: null,
				mvtAccountInvList: [],
				// addOp
				activeAddRow: false,
				rowsAdded: {},
				typeView: 'new', // new, show, edit
				autoSearchPrsKey: 0,
				autoSearchKey: 0,

				pdfSrc:'',
				pdfName:'Facture',
			}
		},
		validations () {
			return this.vueRules
		},
		created (){
			this.vueRules = this.createVeerules()
		},
		async mounted () {
			this.$store.dispatch('initFlash');
			if(this.$store.getters.loggedIn) {
				// GET orderNumber sequence
				await this.$store.dispatch('axiosGet', {
					url: '/api/sequence/getidgenereted?typeSeq=purchaseorder'
				})
				.then(response => {
					if(response.data)
						this.instance.orderNumber = response.data?.id
				})
				.catch(error => {
					console.log('error catch sequence == ', error.message)
				})
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
					if(!this.$store.getters.isAuthorized(['ROLE_MANAGER']) && this.$store.getters.prsInfo.prsStore){
						this.prsStoreSelected = this.$store.getters.prsInfo.prsStore
						this.prsStoreList = this.prsStoreList.filter(item => item.id == this.prsStoreSelected)
					}
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})

				// GET LIST mvtaccountinv
				let strParams = "typeRender=list"
				strParams = strParams+"&params1=prsPerson.id&valParams1="+1+"&logParams1=eqL"
				// strParams = strParams+"&params2=prsStore.id&valParams2="+null+"&logParams2=eqL"

				await this.$store.dispatch('axiosGet', { url: '/api/mvtaccount/getbycriteria?' + strParams
				})
				.then(response => {
					if(response.data){
						this.mvtAccountInvList = response.data;
						this.mvtAccountInvList = this.mvtAccountInvList.filter(item => item.prsStore == null)
					}
				})
				.catch(error => {
					console.log('error catch -mvtAccountInvList == ', error.message)
				})

				// GET LIST prsPersonList
				this.getPersonList()
				// GET LIST servTypeServStoreList
				this.getArticles()

				if(this.itemId && !isNaN(this.itemId)){
					await this.$store.dispatch('axiosGet', {
						domain: 'purchaseorder',
						id: this.itemId
					})
					.then(response => {
						this.typeView = 'show'
						this.instance = response.data
						// console.log('this.instance == ', this.instance)
						this.instance.autoRecep = true // default
						this.instance.orderDate = this.$moment(this.instance.orderDate).format('YYYY-MM-DD').toString()
						if(this.instance.accountPay && this.instance.accountPay.id){
							this.accountPaySelected =  this.instance.accountPay.id
							this.instance.payAuto = true
						}
						this.instance.purchaseOrderItems = []
						this.instance.purchaseOrderItem.forEach(purchaseOrderItem => {
							// console.log('purchaseOrderItem.servTypeServStore == ', purchaseOrderItem.servTypeServStore)
							let arcticles = {
								id: purchaseOrderItem.servType.id,
								lib: purchaseOrderItem.servTypeLib,
								// lib: purchaseOrderItem.servTypeLib + ' | En Stock: '+purchaseOrderItem.servTypeServStore.stock+ ' '+purchaseOrderItem.servType.servUnitLib,
								servType: purchaseOrderItem.servType.id,
								servTypeLib: purchaseOrderItem.servTypeLib,
								quantity: purchaseOrderItem.quantity,
								// stock: purchaseOrderItem.servTypeServStore.stock,
								price: (purchaseOrderItem.cost / purchaseOrderItem.quantity ), 
								cost: purchaseOrderItem.cost,
								edit: true
							}
							this.instance.purchaseOrderItems.push(arcticles)
							this.amountToLetter({target:{value:this.instance.cost?.toString()}}, 'cost')
						})
						this.instance.purchaseOrderItem = [] // on annule l'objet hasMany pour traitement spécial
						// this.prsStoreSelected = this.instance.prsStore.id
						this.paramsSearch.defaultValue = this.instance.person
						this.autoSearchPrsKey=+1;

					})
					.catch(error => {
						console.log('error catch get purchaseorder by itemId == ', error.message)
					})
				}
			}
			this.pageTitle = this.$t('purchaseorder.'+this.typeView)
		},
		methods: {
			async getPersonList(){
				let strParams = "typeRender=list"
				strParams = strParams+"&attrOrder=firstName&typerOrder=asc"			
				// FR -> 3 / FRA -> 5 ,_prsStore
				strParams = strParams+"&aliasList=_prsType"
				strParams = strParams+"&params1=_prsType.id&valParams1="+5+"&logParams1=eqL"
				// if(this.prsStoreSelected && this.prsStoreSelected != null)
				// 	strParams = strParams+"&params2=_prsStore.id&valParams2="+this.prsStoreSelected+"&logParams2=eqL"
				
				strParams = strParams+"&params3=active&valParams3="+true+"&logParams3=eqB"
				// plus utile avec FRA
				// strParams = strParams+"&params4=id&valParams4="+1+"&logParams4=neL"
					
				await this.$store.dispatch('axiosGet', { 
					url: '/api/prsperson/getbycriteria?' + strParams
				})
				.then(response => {
					this.paramsSearch.filterList = response.data
				})
				.catch(error => {
					console.log('error catch paramsSearch.filterList == ', error.message)
				})

			},
			async getArticles(){
				this.instance.purchaseOrderItems = []
				this.paramsSearchArt.filterList = []
				let strParams = "typeRender=list"
				strParams = strParams+"&aliasList=_servService,_servType"
				strParams = strParams+"&attrOrder=_servType.typeName&typerOrder=asc"
				// Cat - > Art
				strParams = strParams+"&params1=_servType.servCategory.id&valParams1="+1+"&logParams1=eqL"
				// Serv Stock : 1
				strParams = strParams+"&params2=_servService.id&valParams2="+1+"&logParams2=eqL"
				await this.$store.dispatch('axiosGet', { 
					url: '/api/servtypeserv/getbycriteria?' + strParams
				})
				.then(response => {
					let arcticles = response.data
					
					arcticles?.forEach(art =>{
						if(art){

							let purchaseOrderItem = {
								id: art.servType.id,
								lib: art.servTypeLib + ' | En Stock: '+this.$store.getters.formatNumber(art.stock)+ ' '+art.servType.servUnitLib,
								servType: art.servType.id,
								servTypeLib: art.servTypeLib,
								quantity: 1, // min 1
								stock: art.stock,
								cost: 0
							}
							this.paramsSearchArt.filterList.push(purchaseOrderItem)
							// cas edit
							this.purchaseOrderItems[art.servTypeLib] = purchaseOrderItem
						}
						
					})
					
				})
				.catch(error => {
					console.log('error catch paramsSearch.filterList == ', error.message)
				})
			},
			prsStoreChange(){
				// 1 - on change liste des clients et products selon store
				this.getPersonList()
				// this.getArticles()
			},
			/*prsAmountChange(){
				this.instance.cost = 0;
				this.instance.purchaseOrderItems?.forEach(art =>{
					this.instance.cost = this.instance.cost + art.cost 
				});
				this.instance.cost = this.instance.cost + this.instance.charges - this.instance.discount
			},*/
			prsAmountChange(){
				this.instance.ht = 0;
				this.instance.purchaseOrderItems?.forEach(art =>{
					this.instance.ht = this.instance.ht + art.cost 
				});
				this.instance.cost = this.instance.ht + this.instance.charges - this.instance.discount //+this.instance.tax
			},
			async editItem(){
				if(this.typeView == 'edit')
					this.$router.go(0)
				else {
					this.typeView = 'edit'
					// on ajoute les autres stocks
					this.instance.purchaseOrderItems.forEach(purchaseOrderItem => {
						if(this.purchaseOrderItems[purchaseOrderItem.servTypeLib]){
							//purchaseOrderItem.stock = this.purchaseOrderItems[purchaseOrderItem.servTypeLib].stock
							delete this.purchaseOrderItems[purchaseOrderItem.servTypeLib];
						}
					})
					let purchaseOrderItems = Object.values(this.purchaseOrderItems);
					// this.instance.purchaseOrderItems.push(...purchaseOrderItems);
					this.paramsSearchArt.filterList = []
					this.paramsSearchArt.filterList.push(...purchaseOrderItems)
				}
			},
			createVeerules(){
				let rules = {
					instance: {
						orderDate: { required },
						orderNumber: {required},
						// prsStore: {required},
						personId: {required},
						purchaseOrderItems: {required},
					}
				}
				return rules
			},
			removeRow(row){
				let newList = this.instance.purchaseOrderItems.filter(item => item.servTypeLib !== row.servTypeLib)
				this.instance.purchaseOrderItems = newList
				this.paramsSearchArt.filterList.push(this.rowsAdded[row.servTypeLib])
			},
			addRow(row){
				if(row){
					// on restraint la liste filter after click
					let newList = this.paramsSearchArt.filterList.filter(item => item.servTypeLib !== row.servTypeLib)
					this.paramsSearchArt.filterList = newList
					
					// cas edit, on bloque l'élement existant dans l'opération
					const idRowsAdded = this.instance.purchaseOrderItems.map(item => item.servTypeLib);
					if(idRowsAdded?.includes(row.servTypeLib)){
						this.$store.dispatch('showToast', {
							type: 'warning', message: row.servTypeLib +' déja choisis'
						});
					}
					else {
						this.instance.purchaseOrderItems.push(row)
						this.rowsAdded[row.servTypeLib] = row
					}
				
				}
				if(this.activeAddRow)
					this.activeAddRow = false
				else
					this.activeAddRow = true
			},
			
			addPerson(row){
				if(row){
					this.instance.personId = row.id?.toString()
					this.instance.livreur = row.id?.fullName
				}
				else {
					this.instance.personId = ''
					this.instance.livreur = ''
				}
			},
			amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async handleSubmit() {
				this.instance.prsStore = this.prsStoreSelected
				// if(this.instance.autoDestock)
				// 	instance.servStatus: {id:3}
				let result = await this.v$.$validate()
				
				//  AUTO 
				if(this.instance.payAuto){
					this.instance.accountPay = this.accountPaySelected
					this.instance.servStatus = {id:1}

					if(!this.accountPaySelected){
						let errors = "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>Veuiller renseigner le compte de paiement si auto pay</li>"
						result = false
						this.$store.getters.getErrorMsgFormatted(errors);
					}
				}

				if (!result){
					return
				}
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},
			async axiosPost() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'purchaseorder',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							// console.log('res update === ', res)
							this.$nextTick(() => {
								let msg = this.$t("purchaseorder.label") + " N° "+res.data?.orderNumber;
								
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.typeView = 'show'
									this.$router.push('/purchaseorder/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									this.$router.go(0)
								}
								// this.typeView = 'show'
								// this.$router.push('/purchaseorder/show/'+this.itemId)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error update === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					else {
						await this.$store.dispatch('axiosPost', {
							domain: 'purchaseorder',
							data: this.instance //data
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("purchaseorder.label") + " N° "+res.data?.orderNumber;
								this.$store.dispatch('showToast', {
									type: 'success', message: this.$t('toast.created.message', { obj: msg})
								});
								this.$router.push('/purchaseorder/show/'+res.data.id)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							// console.log('Error', error.response)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
			async axiosValid() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'purchaseorder/validorder',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							// console.log('res axiosValid === ', res)
							this.$nextTick(() => {
								let msg = this.$t("purchaseorder.label") + " "+this.itemId;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/purchaseorder/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.received.message', { obj: msg})
									});
									this.$router.go(0)
								}
								// this.$router.go(0)
								// this.$router.push('/purchaseorder/show/'+this.itemId)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosValid === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
			async produce(typePrint) {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				let modelName = "BON D'ACHAT"
				let attrsRepList = ['servType', 'getPrice()', 'quantity', 'cost']
				let attrsRepLibList = ['Article', 'P.U', 'Qté.', 'Montant']
				if(typePrint == 'bord'){
					modelName = 'BORDEREAU DE LIVRAISON'
					attrsRepList = ['servType', 'quantity', 'tdObs'] //, 'obs'
					attrsRepLibList = ['Article', 'Qté.', 'Observation']
				}

				let	detailsTop = '<FONT size=5><b>'+modelName+' </b> </FONT>';
				let detailsTopC1 = '<i>'+ this.$t(this.instanceClassAttr.instanceClass +'.personId')+' : </i> <b> ' +this.instance.personInfo.name + '</b>';
				detailsTopC1 = detailsTopC1 + '<br> <i>'+ this.$t('prsperson.address') +' : </i> <b> ' +this.instance.personInfo.address + '</b>';
				detailsTopC1 = detailsTopC1 + '<br> <i>'+ this.$t('prsperson.phoneAddress') +' : </i> <b> ' +this.instance.personInfo.phoneAddress + '</b>';
				
				let	detailsTopC2 = '<i> '+ this.$t('purchaseorder.orderNumber') +' : </i> <b> ' +this.instance.orderNumber + '</b>';
				detailsTopC2 = detailsTopC2 + '<br><i> Bamako le, </i> <b>' + this.$moment(this.instance.orderDate).format(this.$store.getters.formatDateShort) + '</b>';

				let trFoot = ''
				let	detailsBot = ''
				if(typePrint == 'bill'){
					trFoot = '<i> '+ this.$t('purchaseorder.ht') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance?.ht) + '</b>';
				
					if(trFoot != '')
						trFoot = trFoot + '<br>'
					trFoot = trFoot + '<i> '+ this.$t('purchaseorder.discount') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance.discount) + '</b>';
					if(trFoot != '')
						trFoot = trFoot + '<br>'
					trFoot = trFoot + '<i> '+ this.$t('purchaseorder.charges') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance.charges) + '</b>';
					if(trFoot != '')
						trFoot = trFoot + '<br>'
					trFoot = trFoot + '<i> '+ this.$t('purchaseorder.tax') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance?.tax) + '</b>';
					if(trFoot != '')
						trFoot = trFoot + '<br>'
					trFoot = trFoot + '<i> '+ this.$t('purchaseorder.ttc') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance?.cost) + '</b>';
				
					detailsBot = '<i> '+ this.$t('purchaseorder.amountLetter') +' : <b> '+this.amountLetter.cost +'</b> </i>';
				}

				let strParams = "jasper=LIC&typeList=criteria&strFormat=PDF"

				if(detailsTop != '')
					strParams = strParams +"&detailsTop="+detailsTop
				if(detailsTopC1 != '')
					strParams = strParams +"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParams = strParams +"&detailsTopC2="+detailsTopC2
				if(trFoot != '')
					strParams = strParams +"&trFoot="+trFoot
				if(detailsBot != '')
					strParams = strParams +"&detailsBot="+detailsBot

				let strParamsForms = "params1=purchaseOrder.id&valParams1="+this.itemId +"&logParams1=eqL"
				strParamsForms = strParamsForms + "&attrsRepList=" +attrsRepList.toString()+"&attrsRepLibList="+attrsRepLibList.toString()
				strParams = strParams +"&"+strParamsForms

				strParams = strParams + "&titreDoc="+ this.$t(this.instanceClassAttr.instanceClass +'.purchaseOrderItem')

				let fileName = modelName + '_'+this.instance.orderNumber+ '_'+this.instance.personInfo.name
				strParams = strParams + "&fileName="+ fileName
				strParams = strParams + "&storeName=" + '<FONT size=1><i>*** '+this.instance.prsStore?.storeName +' ***</i></FONT> '
				await this.$store.dispatch('axiosGet', {
					url: '/api/purchaseorderitem/produce?' + strParams, strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					this.pdfName = fileName+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},

		}
	}

</script>